module.exports = __webpack_public_path__ + "assets/img/flowbgc.c55186ec.png";